import { render, staticRenderFns } from "./ShippersTable.vue?vue&type=template&id=2c9d3940"
import script from "./ShippersTable.vue?vue&type=script&lang=js"
export * from "./ShippersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports